import Api from 'libs/api';

class UsersApi extends Api {
  constructor() {
    super('admin/users');
  }

  getAll = (params) => {
    return this.buildQuery('get', params);
  };

  getOne = (id) => {
    return this.buildQuery('get', null, id);
  };

  create = (params) => {
    return this.buildQuery('post', params);
  };

  update = (id, params) => {
    return this.buildQuery('put', params, id);
  };

  delete = (id) => {
    return this.buildQuery('delete', null, id);
  };

  bulkCreate = (data) => {
    return this.buildQuery('post', { data }, 'bulk_create');
  };
}

export default UsersApi;
